module.exports = __webpack_public_path__ + "img/何洪涛.efed97d5.jpg";